import { forwardRef, type Ref, type SVGProps } from "react";
const IconTextColorFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" fillRule="evenodd" d="M6 22h5.682l1.12-3.828h6.396L20.318 22H26L19.599 2h-7.197zm12.008-7.89-1.932-6.602h-.152l-1.932 6.601h4.016z" clipRule="evenodd" /><path fill="currentColor" d="M5 24h22a3 3 0 1 1 0 6H5a3 3 0 1 1 0-6" /></svg>;
const ForwardRef = forwardRef(IconTextColorFilledSVG);
ForwardRef.displayName = "IconTextColorFilled";
export { ForwardRef as IconTextColorFilled };